module.exports = __webpack_public_path__ + "img/stairs.ea63aa43.png";